module.exports = __webpack_public_path__ + "static/WhoWeAre-6210b34efa85df8cc861ad946f43679a.png";